import {AndroidOutlined, AppleOutlined, CloseOutlined, SearchOutlined} from "@ant-design/icons";
import React, {useEffect, useRef, useState} from "react";
import {DownOutlined, FilterOutlined} from '@ant-design/icons';
import {useClickAway, useInViewport, useLockFn, useScroll, useUpdateEffect} from "ahooks";
import {Link} from "react-router-dom";
import general, { redux } from "../../general";
import moment from "moment";
import $ from "jquery";
import Dialog from "../../lib/Dialog";
import Image from "../../lib/Image";
import {CSSTransition} from "react-transition-group";
import useActiveState from "../../lib/useActiveState";
import GfyxItem from "../components/GfyxItem";
import CzjlItem from "../components/CzjlItem";
import Manager from "../components/Manager";

const sorts = [
  {
    sort: 'hot',
    text: '热门交易',
  },
  {
    sort: 'havebeenplaying',
    text: '最近在玩',
  },
  {
    sort: 'publish',
    text: '最新发布',
  },
  {
    sort: 'effective',
    text: '性价比高',
  },
  {
    sort: 'asc',
    text: '价格升序',
  },
  {
    sort: 'desc',
    text: '价格降序',
  },
];
const types = [
  {
    type: '1',
    text: 'BT版',
  },
  {
    type: '2',
    text: '折扣',
  },
  {
    type: '3',
    text: 'H5',
  },
  {
    type: '5',
    text: '0.1折',
  },
  {
    type: '6',
    text: 'BT折扣',
  },
  {
    type: '7',
    text: '0.05折',
  },
];
const devices = [
  {
    device: '0',
    text: '双端',
  },
  {
    device: '2',
    text: '苹果',
  },
  {
    device: '1',
    text: '安卓',
  },
];


const pricerange = [
  {
    minPrice: '1',
    maxPrice: '6',
    text: '1-6元',
  },
  {
    minPrice: '6',
    maxPrice: '20',
    text: '6-20元',
  },
  {
    minPrice: '20',
    maxPrice: '50',
    text: '20-50元',
  },
  {
    minPrice: '50',
    maxPrice: '100',
    text: '50-100元',
  },
  {
    minPrice: '100',
    maxPrice: '999999',
    text: '100元以上',
  },
];

export default props => {
  
  const [user] = useActiveState('user');
  const [agent] = useActiveState('agent');
  const [sortIng, setSortIng] = useState();
  const [sort, setSort] = useState(0);
  const [filtering, setFiltering] = useState();
  const [filter, setFilter] = useState({
    sort: undefined,
    type: undefined,
    device: '0',
    minPrice: undefined,
    maxPrice: undefined,
    tag: undefined,
  });
  const [tmpFilter, setTmpFilter] = useState({device:'0'});
  const [tags, setTags] = useState([]);
  const [kw, setKw] = useState('');
  const [priceRouteIndex, setPriceRouteIndex] = useState(-1);
  const [loaded, setLoaded] = useState(false);
  const sortRef = useRef(null);
  useClickAway(() => {
    setSortIng(false);
  }, sortRef);

  const loadTag = useLockFn(async () => {
    // Dialog.loading();
    // location [1:发现， 2：开服， 3：交易]
    let tmp = {
      location:3
    };
    tmp.location = 3;

    general.axios.post('/base/game/getClassifyList', tmp)
      .finally(() => {
        Dialog.close();
      })
      .then(response => {
        let {status, data} = response.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }
        setTags(data.game_classify_list[0].sub_classify_list[0]);
      })
      .catch(err => {
          Dialog.error(err.message);
        });
  });
  useEffect(() => {
    if (tags.length === 0 && filtering) {
      loadTag();
    }
  }, [filtering]);

  const [page, setPage] = useState(1);
  const [trades, setTrades] = useState([]);
  const [more, setMore] = useState(true);

  useEffect(() => {
    redux.subscribe(() => {
      let oid = redux.getState().oid;
      if (oid) {
        const filteredList = trades.filter(
          (item) => item.trade_id != oid
        );
        
        // 更新状态，这将触发组件重新渲染
        setTrades(filteredList);
      }
    })
  },[])

  useEffect(()=>{
    redux.subscribe(() => {
      const state = redux.getState()
      if (state.current_price) {

        setTrades(prevItems =>
          prevItems.map(item =>
            item.trade_id == state.trade_id ? { ...item, trade_price: state.current_price } : item
          )
        );
      }
    })
  },[trades])
  
  const load = useLockFn(async (parms = {}) => {
    if(props.active){
      Dialog.loading();
    }else{
      return
    }
    
    let data = {
      member_id: undefined,
      username: undefined,
      sort_type: tmpFilter.sort != undefined ? sorts[tmpFilter.sort].sort : '',
      game_species_type: filter.type ? types[filter.type].type : '',
      game_device_type: filter.device ? devices[filter.device].device : '',
      trade_featured: props.good ? 1 : 0,
      trade_source: props.source,
      game_name: kw,
      pagination: {count: 10, page},
    };

    //超值捡漏
    // if(data.trade_source == 'czjl') { 
    //   if(priceRouteIndex != '-1') {
    //     data.trade_price_range = pricerange[priceRouteIndex].minPrice + '-' + pricerange[priceRouteIndex].maxPrice;
    //   }
    // } else {
      if (filter.minPrice && filter.maxPrice) {
        data.trade_price_range = filter.minPrice + '-' + filter.maxPrice;
      }
    // }

    if (tags.length > 0) {
      if (filter.tag !== undefined) {
        data.game_classify_id = tags[filter.tag].game_classify_id;
      }
    }
    if (parms.page) {
      data.pagination.page = parms.page;
    }
    if(data.trade_source == 'czjl') {
      setStyleState(false);//竖条显示
      setIsHideSwitch(true);//隐藏切换样式
    }else {
      setStyleState(true);//竖条显示
      setIsHideSwitch(false);//隐藏切换样式
    }
    const url = (props.type === 'project' ? '/user/tradeV2/getExtraleak' : '/user/tradeV2/getTradeList')

    await general.axios.post(url, data)
      .finally(() => {
        Dialog.close();
      })
      .then(res => {
        let {status, data: {account_list, paginated, defult_select}} = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }
        props.handleTitle(res.data.data.title_items)
        setLoaded(true);
        if (parms.page) {
          setPage(parms.page);
          if (parms.page == 1){
            setTimeout(() => {
              window.scrollTo({
                top: 0,
              });
            }, 50);
          }
        }
        setTrades(trades => parms.page === 1 || !parms.page ? account_list : [...trades, ...account_list]);
        if(paginated){
          setMore(paginated.more && account_list.length > 0);
        }
        if (defult_select) {
          const index = sorts.findIndex(s => s.sort == defult_select)
          setTmpFilter({...tmpFilter, sort: index})
        }
      })
      .catch(err => {
        Dialog.error(err.message);
      });
  });
  useEffect(() => {
    load({page: 1});
    if (kw){
      Manager.push({event_id:'A-4-12'})
    }
  }, [ filter, kw]);

  const scroll = useScroll();
  useUpdateEffect(() => {
    if (props.active) {
      if (scroll.top < -80) {
        load({page: 1});
      }
      if (scroll.top + window.innerHeight + 20 >= $(document).height() && more && loaded) {
        load({page: page + 1});
      }
    }
  }, [scroll, props.active, more , loaded]);

  const headRef = useRef(null);
  const headInViewPort = useInViewport(headRef);
  const [opacity, setOpacity] = useState();
  // const [headNewInViewPort, setHeadNewInViewPort] = useState(true);
  useEffect(() => {
    // console.log(headInViewPort);
    // setTimeout(()=>{setHeadNewInViewPort(headInViewPort)}, 300);
  }, [headInViewPort]);

  useEffect(() => {
    let opacity;
    if (props.active) {
      if (scroll.top > 280) {
        // opacity = Math.abs(scroll.top) / 200;
        // if (opacity > 1) {
        //   opacity = 1;
        // }
        opacity = false;
      } else {
        opacity = true;
      }
    }
    setOpacity(opacity);
  }, [scroll, props.active]);

  const [styleState, setStyleState] = useState(true);
  const [isHideSwitch, setIsHideSwitch] = useState(false);

  const upStyleImg = () => {
    let a = styleState == true ? false : (styleState == false ? true : false);
    setStyleState(a);
  }

  //搜索处理
  const [inputFlag, setInputFlag] = useState(false);
  const [inputText, setInputText] = useState('');
  let isOnComposition = false;

  const handleComposition = (e) => {
    //中文输入状态
    if (e.type === 'compositionend') {
      isOnComposition = false;
      setInputText(e.target.value);
      setKw(e.target.value);
      return;
    } else if (e.type === 'compositionstart') {
      Manager.push({event_id:'A-4-12'})
      isOnComposition = true;
      return;
    } else if (e.type === 'compositionupdate') {
      isOnComposition = true;
      return;
    }
    isOnComposition = true;
  }

  const handleChange = (e) => {
    setInputText(e.target.value);
    if (!isOnComposition) {
      setKw(e.target.value);
    }

  }

  const priceMinDeal = (e) => {
    let value = e.target.value.replace(/[^\d]/, '')
    setTmpFilter({...tmpFilter, minPrice: value});
  }

  const priceMaxDeal = (e) => {
    let value = e.target.value.replace(/[^\d]/, '')
    setTmpFilter({...tmpFilter, maxPrice: value})
  }

  //超值捡漏
  useEffect(() => {
    if(props.source == 'czjl') {
      load({page: 1});
    }
  }, [priceRouteIndex]);

  useEffect(()=>{
    if (props.active && trades.length == 0){
      load({page: 1});
    }
  },[props.active,props.good])

  return <div className="trade-list" key={props.id}>
    <div className={'list-head-place' + (!opacity ? ' active' : '')} ref={headRef}/>
    <div className={'list-head' + (!opacity ? ' fixed' : '')}>
      <CSSTransition in={sortIng} timeout={250} unmountOnExit={true}>
        <div className="sorts">
          {sorts.map((item, index) => <div key={index} className={'item' + (sort === index ? ' active' : '')} onClick={() => {
            setSort(index);
            setSortIng(false);
          }}>{item.text}</div>)}
        </div>
      </CSSTransition>
      <div className="input">
        <img src="/resources/user/ss.png" className="icon" />
        <input type="text" value={inputText || ''} placeholder="请输入游戏"
            onCompositionStart = {handleComposition}
            onCompositionUpdate = {handleComposition}
            onCompositionEnd = {handleComposition}
            onChange = {handleChange}
            />
        {kw || inputText ? <CloseOutlined className="close" onClick={() => {setKw('');setInputText('')}}/> : null}
      </div>
      <div className="sort" onClick={() => {
        setFiltering(true)
        Manager.push({event_id:'A-4-13'})
      }} ref={sortRef}>
        <span className="title">{sorts[tmpFilter?.sort]?.text}</span>
        <img src="/resources/trade/down-jt.png" className="icon" style={{width:'10px'}}/>
      </div>
    </div>

    {/* {props.source == 'czjl' ?
    <div className={"list-select " + (!opacity ? ' fixed' : '')}>
      <div className="items">
        {
          pricerange.map((t, i) => <div className={"item " + (priceRouteIndex == i ? 'active' : '')} onClick={()=>{ i==priceRouteIndex ? setPriceRouteIndex(-1) : setPriceRouteIndex(i)}}>
            {t.text}
          </div>)
        }
      </div>
    </div>
    : null} */}

    <div className="list-body clearfix">
      {trades?.map((item,index)=>{
        return (
          <>
          <GfyxItem key={item.trade_id}>{item}</GfyxItem>
          </>
        )
      })}
      {trades.length === 0 && loaded ? <div className="recovery-empty"><img src="/resources/game/detail-trade-place.png" alt=""/>暂无数据</div> : null}
    </div>
    {trades.length > 0 && !more ? <div className="view-end">别撩啦！已经到底啦~</div> : null}
    <CSSTransition in={filtering} timeout={250} unmountOnExit={true}>
      <div className="list-filter">
        <div className="mask" onClick={() => setFiltering(false)}/>
        <div className="container">
          <div className="title">排序方式</div>
          <div className="type">
          {sorts.map((item, index) => <div key={index} className={'item' + (index == tmpFilter.sort ? ' active' : '')} onClick={() => setTmpFilter({...tmpFilter, sort: index})}>{item.text}</div>)}
          </div>
          {/* <div className="title">游戏专区</div>
          <div className="type">
            {types.map((item, index) => <div key={index} className={'item' + (index === tmpFilter.type ? ' active' : '')} onClick={() => setTmpFilter({...tmpFilter, type: index})}>{item.text}</div>)}
          </div> */}
          <div className="title">设备</div>
          <div className="type">
            {devices.map((item, index) => <div key={index} className={'item' + (index == tmpFilter.device ? ' active' : '')} onClick={() => setTmpFilter({...tmpFilter, device: index})}>{item.text}</div>)}
          </div>
          <div>
          <div className="title">价格区间</div>
          <div className="prices">
            <input type="number" placeholder="最低价格" value={tmpFilter.minPrice} onChange={priceMinDeal} />
            <span style={{color:'#E4E4E4'}}>&nbsp;&nbsp;&nbsp;&nbsp;——&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <input type="number" placeholder="最高价格" value={tmpFilter.maxPrice} onChange={priceMaxDeal} />
          </div>
          </div>
          {/* <div className="title">游戏分类</div>
          <div className="tag">
            <div className={'item' + (tmpFilter.tag === undefined ? ' active' : '')} onClick={() => setTmpFilter({...tmpFilter, tag: undefined})}><span>全部</span></div>
            {tags.map((item, index) => <div key={index} className={'item' + (index === tmpFilter.tag ? ' active' : '')} onClick={() => setTmpFilter({...tmpFilter, tag: index})}><span>{item.game_classify_name}</span></div>)}
          </div> */}
          <div className="operate">
            <div className="btn" onClick={() => {
              const init = {
                sort: 0,
                type: undefined,
                device: '0',
                minPrice: '',
                maxPrice: '',
                tag: undefined
                }
              setTmpFilter(init)}
            }>重置</div>
            <div className="btn" onClick={() => {
              setFiltering(false);
              setFilter({...tmpFilter});
            }}>确定
            </div>
          </div>
        </div>
      </div>
    </CSSTransition>
  </div>;
};